module.exports = __webpack_public_path__ + "models/scene1.3f368f1.atlas";